import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../feature-module/router/all_routes";


interface Props {
  heading?: string
  message?: string,
  btnText?: string,
  renderIcon?: ()=> JSX.Element
  onConfirm?: ()=>void
}

const SuccessModal = (props: Props) => {
 
  return (
    <>
      <>
        {/* Success Modal */}
        <div className="modal fade" id="success_modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <span className="avatar avatar-xl bg-transparent-success text-success mb-3">
                  {props.renderIcon ? props.renderIcon() : <i className="ti ti-check fs-36" />} 
                </span>
                <h4 className="mb-1">{ props.heading ? props.heading : "Confirm Yes"}</h4>
                <p className="mb-3">
                  {props.message ? props.message : "You want to perform this operation, this cant be undone once you delete."}
                </p>
                <div className="d-flex justify-content-center">
                 <Link
                    to="#"
                    className="btn btn-light me-3"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                 <Link to="#" 
                    data-bs-dismiss="modal" 
                    className="btn btn-success" 
                    onClick={props.onConfirm}>
                    {props.btnText ? props.btnText : 'Yes, Confirm'}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Success Modal */}
      </>

    </>

  );
};

export default SuccessModal;

